module.exports = __webpack_public_path__ + "img/chain20.1d7acf14.png";